import { render, staticRenderFns } from "./agency.vue?vue&type=template&id=6dd90c3b&scoped=true&lang=pug"
import script from "./agency.vue?vue&type=script&lang=ts"
export * from "./agency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd90c3b",
  null
  
)

export default component.exports